import CreatePersonalizedNotification from './CreatePersonalizedNotification';
import EditPersonalizedNotification from './EditPersonalizedNotification';
import ListPersonalizedNotifications from './ListPersonalizedNotifications';

export default {
  create: CreatePersonalizedNotification,
  list: ListPersonalizedNotifications,
  edit: EditPersonalizedNotification,
};
